import { Box } from '@mui/material';
import { ExoSkeleton } from '../../components/exo/ExoSkeleton';

// Mirrors the CourseView layout (breadcrumb, title, description, progress
// card and lesson lists) so the page doesn't jump when the courses arrive
export const CourseSkeleton = () => (
  <Box component="main" className="flex-1 min-w-0 h-full overflow-y-auto">
    <Box className="mx-auto" sx={{ maxWidth: '780px', padding: '28px 40px 80px' }}>
      <ExoSkeleton width="280px" size="14px" borderRadius="6px" />

      <Box sx={{ margin: '18px 0 6px' }}>
        <ExoSkeleton width="55%" size="32px" borderRadius="8px" />
      </Box>

      <Box className="flex flex-col" sx={{ gap: '8px', margin: '8px 0 22px', maxWidth: '560px' }}>
        <ExoSkeleton size="13px" borderRadius="6px" />
        <ExoSkeleton width="70%" size="13px" borderRadius="6px" />
      </Box>

      <Box sx={{ marginBottom: '28px' }}>
        <ExoSkeleton size="92px" borderRadius="12px" />
      </Box>

      <Box sx={{ marginBottom: '10px' }}>
        <ExoSkeleton width="130px" size="12px" borderRadius="6px" />
      </Box>
      <Box className="flex flex-col" sx={{ gap: '8px', marginBottom: '26px' }}>
        <ExoSkeleton n={4} size="58px" borderRadius="11px" />
      </Box>

      <Box sx={{ marginBottom: '10px' }}>
        <ExoSkeleton width="110px" size="12px" borderRadius="6px" />
      </Box>
      <Box className="flex flex-col" sx={{ gap: '8px' }}>
        <ExoSkeleton n={3} size="58px" borderRadius="11px" />
      </Box>
    </Box>
  </Box>
);
